import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import { useTheme } from '../contexts/ThemeContext';
interface WelcomeScreenProps {
  onGetStarted: () => void;
  onExplore: () => void;
}
export function WelcomeScreen({
  onGetStarted,
  onExplore
}: WelcomeScreenProps) {
  const {
    isLight
  } = useTheme();
  return <div className="h-full flex flex-col items-center justify-between p-6 relative overflow-hidden" data-id="element-2486">
      {/* Decorative gradient orbs for glass depth */}
      <div className={`absolute top-20 -left-20 w-60 h-60 rounded-full blur-3xl pointer-events-none ${isLight ? 'bg-vexu/20' : 'bg-vexu/10'}`} data-id="element-2487" />
      <div className={`absolute bottom-40 -right-20 w-60 h-60 rounded-full blur-3xl pointer-events-none ${isLight ? 'bg-vexu/10' : 'bg-vexu/5'}`} data-id="element-2488" />

      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-8 w-full relative z-10" data-id="element-2489">
        <div className="relative" data-id="element-2490">
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} className={`absolute inset-0 blur-3xl rounded-full animate-pulse ${isLight ? 'bg-vexu opacity-30' : 'bg-vexu opacity-20'}`} data-id="element-2491" />
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          type: 'spring'
        }} className={`relative w-32 h-32 rounded-[32px] overflow-hidden transition-colors duration-500 shadow-2xl shadow-vexu/10`} data-id="element-2492">
            <img src="https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg" alt="Vexu Logo" className="w-full h-full object-cover scale-[1.15]" data-id="element-2493" />
          </motion.div>
        </div>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="space-y-3 max-w-xs" data-id="element-2494">
          <h1 className={`text-4xl font-bold tracking-tight transition-colors duration-500 ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-2495">
            Vexu.ai
          </h1>
          <p className={`text-lg font-medium transition-colors duration-500 ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-2496">
            Your AI personal assistant
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.6
    }} className="w-full space-y-4 mb-8 relative z-10" data-id="element-2497">
        <Button fullWidth size="lg" onClick={onGetStarted} className={isLight ? 'shadow-lg shadow-vexu/20' : 'shadow-lg shadow-vexu/20'} data-id="element-2498">
          Get Started
        </Button>
        <button onClick={onExplore} className={`w-full text-center text-sm font-medium transition-colors ${isLight ? 'text-slate-500 hover:text-slate-900' : 'text-zinc-500 hover:text-white'}`} data-id="element-2499">
          Explore App
        </button>
      </motion.div>
    </div>;
}